// import Swiper JS
import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';

( function( $ ) {
    //Iedereen heeft wat SVG
    if( $( ".iedereenheeftwat" ).length ) {

        var ihwSlider = new Swiper('.carousel', {
            modules: [Navigation, Pagination, Autoplay],
            loop: true,
            autoplay: false,
            speed: 300,
            slidesPerView: 2,
            slidesPerGroup: 2,
            passiveListeners: true, //recommended for mobile performance
            centeredSlides: false,
            on: {
                init: function () {
                    startNames();
                },
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            pagination: {
                el: ".swiper-pagination",
                clickable: true,
            },
            breakpoints: {
                1024: {
                  slidesPerView: 2,
                  slidesPerGroup: 2
                },
                600: {
                slidesPerView: 2,
                slidesPerGroup: 2
                },
                480: {
                slidesPerView: 1,
                slidesPerGroup: 1
                }
            },
        });

        //show text balloons
        $( ".ihw" ).on('click', function () {
            closeSpeech();
            var className = $( this ).attr( "class" );
            className = className.replace( "ihw ", "" );
            $( ".speech." + className ).fadeIn( "slow" );
            $( ".speech." + className + " .close" ).fadeIn( "slow" );
            $( ".speech." + className + " .text" ).fadeIn( "slow" );
        } );

        $( ".name" ).on('click', function () {
            var className = $( this ).parent().parent().attr( "class" );
            className = className.replace( "speech ", "" );
            $( ".speech." + className ).fadeIn( "slow" );
            $( ".speech." + className + " .close" ).fadeIn( "slow" );
            $( ".speech." + className + " .text" ).fadeIn( "slow" );
        } );


        function getSpeechShown() {
            var textShown = false;
            $( ".speech .text" ).each( function() {
                if( $( this ).css( "display" ) == "block" ) {
                    textShown = true;
                }
            } );

            if( !textShown ) {
                textShown = $( '.iedereenheeftwat' ).data( 'stop-speech' );
            }

            return textShown;
        }

        function stopNames() {
            $( '.iedereenheeftwat' ).data( 'stop-speech', true );
        }

        //show names after each other
        function startNames() {
            if( $( window ).width() > 480 ) {
                $( '.iedereenheeftwat' ).data( 'stop-speech', false );

                var $active_names = $( '.swiper-slide-active .trigger-ihw' );
                var active_classnames = [];
                var $names, //$( '.speech' ),
                index = 0;

                $active_names.each( function() {
                    var className = $( this ).attr( "class" );
                    className = className.replace( "trigger-ihw trigger-", "" );
                    active_classnames.push( ".speech." + className );
                });

                $names = $( active_classnames.join( "," ) );
                $names.eq( index++ ).fadeIn().delay( 4000 ).fadeOut( function next() {

                    var textShown = getSpeechShown();
                    var className = $( this ).attr( "class" );
                    className = className.replace( "speech ", "" );

                    if( !textShown && $( ".trigger-" + className ).parent().hasClass( 'swiper-slide-active' ) ) {
                        $names.eq( index++ % $names.length ).fadeIn().delay( 4000 ).fadeOut( next );
                    }
                } );
            }
        }

        //close button speech bubble
        $( ".speech .close" ).on('click', function () {
            closeSpeech();
            //startNames();
        } );

        //close open speech bubble when sliding
        $( ".swiper-arrow" ).on('click', function () {
            closeSpeech();
            startNames();
        });

        //close speech bubble
        function closeSpeech() {
            $( ".speech" ).css( "display","none" );
        }
    }
} )( jQuery );
